import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useI18n } from "../../../hooks/useI18n";
import { get } from "../../../api/api";
import { Payout } from "../../../models/Payout";
import { ProblemDetails } from "../../../models/Http";
import { Currency } from "../../../components/misc/Currency";
import StatTable from "../components/StatTable";
import TableWrapper from "../components/TableWrapper";
import MaterialTable from "@material-table/core";
import PayoutTransactions from "./PayoutTransactions";

const fetchPayouts = async () => {
  const response = await get(`/v1/statistics/payouts`);
  const data = await response.json();
  return data;
};

export const Payouts = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["payouts"],
    queryFn: fetchPayouts,
    staleTime: Infinity
  });

  const { t } = useI18n();

  return (
    <div>
      <TableWrapper title={t("common.tableHeaders.payouts")}>
        <StatTable
          // title={""}
          pageSize={20}
          isLoading={isLoading}
          columns={[
            {
              title: t("common.tableHeaders.arrivalDate"),
              field: "arrivalDate"
            },
            {
              title: t("common.tableHeaders.payoutAmount"),
              field: "amount",
              render: (rowData: any) => <Currency value={rowData.amount} />
            },
            {
              title: "Status",
              field: "status"
            }
          ]}
          data={data}
          actions={[
            {
              icon: "download",
              iconProps: { style: { color: "rgba(0, 0, 0, 0.54)" } },
              tooltip: "Download vat report",
              onClick: async (event: any, row: any) => {
                const url = `/v1/statistics/payout-vat-report/${row.id}`;
                window.open(url);
              }
            }
          ]}
        />
      </TableWrapper>
    </div>
  );
};

export default Payouts;
